import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'sh-permissions-main',
	template: '',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class PermissionsMainComponent {}
